import React,{useRef} from 'react'
import {FiMail} from 'react-icons/fi'
import './contact.css'
import emailjs from '@emailjs/browser';

function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_u0rqmrl', 'template_rw39bep', form.current, 'kMw-QDUPMl-hGOfZI')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });

      e.target.reset()
  };
  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className='container contact__container'>
        <div className='contact__options'>
          <article className='contact__option'>
          <FiMail className='contact__option-emoji'/>
            <h4>Email</h4>
            <h5>gchetan2000@gmail.com</h5>
            <a href='mailto:gchetan2000@gmail.com' target='_blank' rel='noreferrer'>Send a message</a>
          </article>
          <article className='contact__option'>
            <FiMail className='contact__option-emoji'/>
            <h4>Twitter</h4>
            <h5>chetan_data</h5>
            <a href='https://twitter.com/messages/compose?recipient_id=1428408926903562242' target='_blank' rel="noreferrer">Send a message</a>
          </article>
          <article className='contact__option'>
            <FiMail className='contact__option-emoji'/>
            <h4>WhatsApp</h4>
            <h5>6300014049</h5>
            <a href='https://wa.me//+916300014049' target='_blank' rel="noreferrer">Send a message</a>
          </article>
        </div>
        {/* End of Contact options */}
        <form ref={form} onSubmit={sendEmail}>
          <input type='text' name='name' placeholder='Your Full Name' required/>
          <input type='email' name='email' placeholder='Your Email' required/>
          <textarea name='message' placeholder='Your Message' required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact